<template>
    <div id="e4h-quiz-wrapper-component">
        <div id="e4h-quiz" v-if="quizVisible">
            <div class="e4h-quiz-close" v-on:click="toggleQuiz">X</div>
            <div class="e4h-quiz-container" v-bind:class="{ e4hquizmultiplecontainer: (hasResult == true && result.length == 2)}">
                <div class="e4h-question-Container" v-if="hasResult != true && waitForResult == false" v-bind:key="questionindex">
                    <div class="progressContainer">
                        <progress class="progress is-info is-small" :value="quizPositionPercent" :max="quizPositionPercentMax">{{quizPositionPercent}} %</progress>
                    </div>
                    <div class="e4h-header"></div>
                    <div class="e4h-body">
                        <div class="e4h-question">{{ quiz.questions[questionindex].text }}</div>
                        <div class="e4h-answers">
                            <div class="e4h-answers-multiplechoice" v-if="quiz.questions[questionindex].type == 'singlechoice'">
                                <div class="e4h-answer-item" v-for="(response, rIndex) in quiz.questions[questionindex].responses" v-on:click="setAnswer(questionindex, rIndex)" v-bind:key="rIndex">{{ response.text }}</div>
                            </div>
                            <div class="e4h-answers-text" v-if="quiz.questions[questionindex].type == 'text'">
                                <div class="e4h-answer-item nohover"><input type="text" v-model="text" v-on:keyup.enter="setAnswer(questionindex, text)" autofocus/> Jahre</div>
                                <button type="button" class="button primary" v-on:click="setAnswer(questionindex, text)" :disabled="!text">Weiter</button>
                            </div>
                            <button type="button" class="button backbutton" v-on:click="back()" v-if="questionindex > 10">Zurück</button>
                        </div>
                        <div class="e4h-explanation" v-if="quiz.questions[questionindex].explanation" v-html="quiz.questions[questionindex].explanation">
                        </div>
                    </div>
                </div>
                <div class="e4h-loading" v-if="waitForResult == true">
                    <div class="e4h-large">Ergebnis wird berechnet...</div>
                    <img src="./assets/loading.gif"/>
                </div>
                <div class="e4h-result e4h-large" v-if="hasResult == true && result.length == 1">
                    <p>{{ result[0].name }} </p>
                    <a class="button" :href="'/?add-to-cart=' + result[0].productId" v-on:click="clickAddToCartButton">In den Warenkorb</a> <br/>
                    <div class="e4h-result-row">
                        <div class="e4h-result-column">
                            <img :src="result[0].image">
                            <p class="e4h-result-description" v-if="result[0].description">{{ result[0].description }}</p> <br/>
                        </div>
                        <div class="e4h-result-column">
                            <div class="params" v-if="result[0].params" v-html="result[0].params"></div>
                        </div>
                    </div>
                    <!--<p>Für die genaue Auswertung Ihres Mikronährstoffbedarfs ist eine Blutabnahme nötig, diese kann von einem Arzt oder medizinischem Fachpersonal schnell und reibungslos durchgeführt werden. Die Kosten dafür belaufen sich auf 5,00 € bis 15,00 €</p>-->
                </div>
                <div class="e4h-result e4h-large" v-if="hasResult == true && result.length == 2">
                    <div class="e4h-multipleresults">
                        <div class="e4h-subresult">
                            <p>{{ result[0].name }} </p>
                            <a class="button" :href="'/?add-to-cart=' + result[0].productId" v-on:click="clickAddToCartButton">In den Warenkorb</a> <br/>
                            <div class="e4h-result-row" style="flex-direction:column;">
                                <div class="e4h-result-column">
                                    <img :src="result[0].image">
                                    <p class="e4h-result-description" v-if="result[0].description">{{ result[0].description }}</p> <br/>
                                </div>
                                <div class="e4h-result-column">
                                    <div class="params" v-if="result[0].params" v-html="result[0].params"></div>
                                </div>
                            </div>
                        </div>
                        <div class="e4h-subresult">
                            <p>{{ result[0].name }} </p>
                            <a class="button" :href="'/?add-to-cart=' + result[1].productId" v-on:click="clickAddToCartButton">In den Warenkorb</a> <br/>
                            <div class="e4h-result-row" style="flex-direction:column;">
                                <div class="e4h-result-column">
                                    <img :src="result[1].image">
                                    <p class="e4h-result-description" v-if="result[1].description">{{ result[1].description }}</p> <br/>
                                </div>
                                <div class="e4h-result-column">
                                    <div class="params" v-if="result[1].params" v-html="result[1].params"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jQuery from 'jquery';

    const RESULT_PERFORMANCE="performance";
    const RESULT_SLEEP = "sleep";
    const RESULT_METABOLIC = "metabolic";
    const RESULT_TAP = "tapdevice";

    let e4hData = window.e4hData || {params_sleep:"", params_metabolic:"", params_performance:"", params_tap:"", params_init: ""};

    let gQuiz = {
        questions: {
            10: {
                text: "Welchen Bereich in Ihrem Leben wollen Sie optimieren?",
                type: "singlechoice",
                responses: [
                    {text: "Schlafverhalten verbessern", track: "sleep"},
                    {text: "Performance steigern", track: "performance"},
                    {text: "Stoffwechsel aktivieren", track: "metabolic"},
                    {text: "Allgemeines Wohlbefinden steigern", track: "overall"}
                ],
                nextIndex: 20
            },
            20: {
                text: "Geschlecht",
                type: "singlechoice",
                responses: [
                    {text: "Männlich"},
                    {text: "Weiblich"},
                    {text: "Andere"}
                ],
                nextIndex: 30,
                prevIndex: 10
            },
            30: {
                text: "Alter",
                type: "text",
                nextIndex: 40,
                prevIndex: 20
            },
            40: {
                text: "Wie viel Sport machen Sie?",
                type: "singlechoice",
                responses: [
                    {text: "Mehrmals pro Woche"},
                    {text: "Ein- bis Zweimal pro Woche"},
                    {text: "Gar nicht"}
                ],
                nextIndex: 50,
                prevIndex: 30
            },
            50: {
                text: "Nehmen Sie Nahrungsergänzungsmittel?",
                type: "singlechoice",
                responses: [
                    {text: "Ja"},
                    {text: "Nein"}
                ],
                prevIndex: 40
            },
            110: {
                text: "Haben sie Schlafprobleme?",
                type: "singlechoice",
                responses: [
                    {text: "Häufig"},
                    {text: "Selten"},
                    {text: "Nie"},
                ],
                nextIndex: 120,
                prevIndex: 50
            },
            120: {
                text: "Haben Sie Probleme mit Ihrem Stoffwechsel (z.B. Verdauungsbeschwerden, Diabetes mellitus, starkes Über-/Untergewicht)?",
                type: "singlechoice",
                responses: [
                    {text: "Ja"},
                    {text: "Nein"},
                ],
                nextIndex: 130,
                prevIndex: 110
            },
            130: {
                text: "Haben Sie Akne, Psoriasis, depressive Verstimmungen oder eine starke Stressbelastung im Alltag?",
                type: "singlechoice",
                responses: [
                    {text: "Ja"},
                    {text: "Nein"},
                ],
                prevIndex: 120
            }
        },

        /*
        addonQuestions: {
            performance: {
                110: {
                    text: "Haben sie Schlafprobleme?",
                    type: "singlechoice",
                    responses: [
                        {text: "Häufig"},
                        {text: "Selten"},
                        {text: "Nie"},
                    ],
                    nextIndex: 120,
                    prevIndex: 50
                },
                120: {
                    text: "Haben Sie Probleme mit Ihrem Stoffwechsel (z.B. Verdauungsbeschwerden, Diabetes mellitus, starkes Über-/Untergewicht)?",
                    type: "singlechoice",
                    responses: [
                        {text: "Ja"},
                        {text: "Nein"},
                    ],
                    nextIndex: 130,
                    prevIndex: 110
                },
                130: {
                    text: "Haben Sie Akne, Psoriasis, depressive Verstimmungen oder eine starke Stressbelastung im Alltag?",
                    type: "singlechoice",
                    responses: [
                        {text: "Ja"},
                        {text: "Nein"},
                    ],
                    prevIndex: 120
                }
            },
            overall: {
                110: {
                    text: "Haben sie Schlafprobleme?",
                    type: "singlechoice",
                    responses: [
                        {text: "Häufig"},
                        {text: "Selten"},
                        {text: "Nie"},
                    ],
                    nextIndex: 120,
                    prevIndex: 50
                },
                120: {
                    text: "Haben Sie Probleme mit Ihrem Stoffwechsel (z.B. Verdauungsbeschwerden, Diabetes mellitus, starkes Über-/Untergewicht)?",
                    type: "singlechoice",
                    responses: [
                        {text: "Ja"},
                        {text: "Nein"},
                    ],
                    nextIndex: 130,
                    prevIndex: 110
                },
                130: {
                    text: "Haben Sie Akne, Psoriasis, depressive Verstimmungen oder eine starke Stressbelastung im Alltag?",
                    type: "singlechoice",
                    responses: [
                        {text: "Ja"},
                        {text: "Nein"},
                    ],
                    prevIndex: 120
                }
            }
        },
        */

        results: {
            [RESULT_SLEEP]: {
                name: 'Mikronährstoff-Schlafverhalten-Analyse',
                description: 'Für die genaue Auswertung Ihres Mikronährstoffbedarfs ist eine Blutabnahme nötig, diese kann von einem Arzt oder medizinischem Fachpersonal schnell und reibungslos durchgeführt werden. Die Kosten dafür belaufen sich auf ca. 5,00 € bis 15,00 €',
                productId: 23444,
                image: '/wp-content/uploads/2020/07/Analysebox-Schlaf-600x450.jpg',
                params: e4hData.params_sleep
            },
            [RESULT_METABOLIC]: {
                name: 'Mikronährstoff-Stoffwechsel-Analyse',
                description: 'Für die genaue Auswertung Ihres Mikronährstoffbedarfs ist eine Blutabnahme nötig, diese kann von einem Arzt oder medizinischem Fachpersonal schnell und reibungslos durchgeführt werden. Die Kosten dafür belaufen sich auf ca. 5,00 € bis 15,00 €',
                productId: 23446,
                image: '/wp-content/uploads/2020/07/Analysebox-Stoffwechsel-600x450.jpg',
                params: e4hData.params_metabolic
            },
            [RESULT_PERFORMANCE]: {
                name: 'Mikronährstoff-Performance-Analyse',
                description: 'Für die genaue Auswertung Ihres Mikronährstoffbedarfs ist eine Blutabnahme nötig, diese kann von einem Arzt oder medizinischem Fachpersonal schnell und reibungslos durchgeführt werden. Die Kosten dafür belaufen sich auf ca. 5,00 € bis 15,00 €',
                productId: 23442,
                image: '/wp-content/uploads/2020/07/Analysebox-Performance-600x450.jpg',
                params: e4hData.params_performance
            },
            [RESULT_TAP]: {
                name: 'Mikronährstoff-Selbsttest-Analyse (TAP® Device)',
                description: 'Wir schicken Ihnen einen TAP® Device zu, mit diesem können Sie ganz einfach und schmerzfrei selbst Blut am Oberarm abnehmen.',
                productId: 23440,
                image: '/wp-content/uploads/2020/07/Analysebox-Tap-600x450.jpg',
                params: e4hData.params_tap
            }
        }


    };

    export default {
        name: 'E4HQuiz',
        data: function () {
            return {
                //pluginsUrl: "",//e4hFooter.pluginsUrl,
                quiz: gQuiz,
                text: null,
                hasResult: false,
                waitForResult: false,
                result: [],
                track: null,
                questionindex: 10,
                movedToBody: false,
            }
        },
        methods: {
            clickAddToCartButton: function() {
                if(window.gtag) {
                    window.gtag('event', 'add-to-cart', {event_category: "boxselector", event_label: this.track});
                }
            },
            setAnswer: function(qIndex, rIndex) {
                //console.log('ANSWER for Question ' + qIndex + ' --> ' + rIndex);

                if(window.gtag) {
                    //window.ga('send', 'event', 'boxselector', 'progress', this.qIndex);
                    window.gtag('event', 'progress', {event_category: "boxselector", event_label: qIndex});
                }

                this.$set(this.quiz.questions[qIndex], 'answer', rIndex);

                // First Question
                if(qIndex == 10) {
                    let answer = this.quiz.questions[10].responses[rIndex];
                    this.track = answer.track;
                }

                // Quiz has next index
                if(this.quiz.questions[qIndex].nextIndex) {
                    this.questionindex = this.quiz.questions[qIndex].nextIndex;
                }

                // Question ID 50 - next step depends on Track
                if(qIndex == 50) {
                    if(this.track == 'sleep' || this.track == 'metabolic') {
                        this.calculateResult();
                        return;
                    }
                    this.questionindex = 110;
                }
                if(qIndex == 130) {
                    this.calculateResult();
                    return;
                }
                return;
            },
            calculateResult: function() {

                if(window.gtag) {
                    //window.ga('send', 'event', 'boxselector', 'result');
                    window.gtag('event', 'result', {event_category: "boxselector"});
                }

                if(this.track == 'sleep') {
                    this.$set(this.result, 0, this.quiz.results[RESULT_SLEEP]);
                } else if(this.track == 'metabolic') {
                    this.$set(this.result, 0, this.quiz.results[RESULT_METABOLIC]);
                } else {
                    if(this.quiz.questions[120].answer == 0) {
                        // Stoffwechselprobleme -> JA
                        this.$set(this.result, 0, this.quiz.results[RESULT_METABOLIC]);
                    } else {
                        //Stoffwechselprobleme -> NEIN
                        if(this.quiz.questions[110].answer == 0) {
                            // Schlafverhalten -> Häufig
                            if(this.quiz.questions[130].answer == 0) {
                                this.$set(this.result, 0, this.quiz.results[RESULT_METABOLIC]);
                            } else {
                                this.$set(this.result, 0, this.quiz.results[RESULT_SLEEP]);
                            }
                        } else {
                            //Akne -> Ja
                            if(this.quiz.questions[130].answer == 0) {
                                this.$set(this.result, 0, this.quiz.results[RESULT_METABOLIC]);
                            } else {
                                this.$set(this.result, 0, this.quiz.results[RESULT_PERFORMANCE]);
                                this.$set(this.result, 1, this.quiz.results[RESULT_TAP]);
                            }
                        }

                    }
                }

                this.waitForResult = true;

                var myTimerPromise = new Promise((resolve, reject) => {
                    setTimeout(() => {
                        // callback function for timer, gets called after the time-delay
                        // Your timer is done now. Print a line for debugging and resolve myTimerPromise
                        //console.log("2 seconds up, resolving myTimerPromise")
                        this.waitForResult = false;
                        this.hasResult = true;
                        resolve();
                    }, 1500);  // This promise will be resolved in 2000 milli-seconds
                });
                //alert("Result");
            },
            showQuiz: function() {

                document.body.appendChild(this.$el);
                this.quizVisible = true;
                /*
                if(this.movedToBody != true) {
                  this.$nextTick(function () {
                    console.log("QUIZ ELEMENT");
                    console.log(jQuery('#e4h-quiz'));
                    this.movedToBody = true;
                    jQuery(document.body).prepend(jQuery('#e4h-quiz').detach());
                  });
                }
                */

            },
            toggleQuiz: function() {
                //console.log(this.$root.showQuiz);
                if(this.$parent.quizVisible == true) {
                    this.$parent.quizVisible = false;
                    jQuery('body').removeClass('noscroll');
                } else {
                    jQuery('body').addClass('noscroll');
                    this.$parent.quizVisible = true;
                }
            },
            back: function() {
                if(typeof this.quiz.questions[this.questionindex].prevIndex == "number") {
                    this.questionindex = this.quiz.questions[this.questionindex].prevIndex;
                }
            },
            restartQuiz() {
                Object.assign(this.$data, this.$options.data.apply(this));

                let qIds = Object.keys(this.quiz.questions);
                for(let i = 0; i < qIds.length; i++) {
                    let question = this.quiz.questions[qIds[i]];
                    if(Array.isArray(question.answer)) {
                        question.answer = [];
                    } else {
                        delete question.answer;
                    }
                }
                this.result = [];
                this.questionindex = 10;
                this.track = null;
                this.hasResult = false;
                this.waitForResult = false;

            },
        },
        mounted: function() {
            document.body.appendChild(this.$el);
            /*
            this.$el.parentNode.insertBefore(this.$el.children[0], null);
            console.log(this.$el.children);
            document.body.appendChild(this.$el);
             */
        },
        computed: {
            quizVisible() {
                return this.$parent.quizVisible;
            },
            quizPositionPercentMax() {
                if(this.track == 'sleep' ||this.track == 'metabolic') {
                    return 60;
                }
                return 90;
            },
            quizPositionPercent() {
                let keys = Object.keys(this.quiz.questions).filter(function(value, index, array) {
                    return value % 10 == 0;
                });
                let currentIndex = keys.indexOf(this.questionindex.toString())
                let currentIndexTen = Math.ceil(this.questionindex / 10) * 10;
                if(currentIndexTen > 50) {
                    currentIndexTen = currentIndexTen - 50;
                }
                return currentIndexTen;
                //return Math.round(currentIndex / keys.length * 100);
            },
            quizlength() {
                if(this.track) {
                    if(this.track == 'sleep' ||this.track == 'metabolic') {
                        return 5;
                    }
                    return 8;
                }
                let keys = Object.keys(this.quiz);
                return keys.length;
                //return this.$root.quizlength;
            },
        },
        watch: {
            hasResult: function(val) {
                if(val === true) {
                    var myTimerPromise = new Promise((resolve, reject) => {
                        setTimeout(() => {
                            //console.log("HAS RESULT WATCHER");
                            let paramsInit = e4hData.params_init;
                            let paramsFunc = window[paramsInit];
                            if (typeof paramsFunc === "function") paramsFunc();
                            resolve();
                        }, 200);  // This promise will be resolved in 2000 milli-seconds
                    });

                }
            }
        }
    }
</script>

<style>
    /*
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  */

    .noscroll {
        overflow: hidden;
        max-height: 100vh;
    }

    #e4h-quiz {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100vw;
        height: 100vh;
        background-color: rgba(255,255,255,0.95);
        color: black;
        z-index:100;
        display: flex;
        overflow-y: scroll;
    }

    .e4h-quiz-close {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 2em;
        cursor: pointer;
    }

    .e4h-quiz-container {
        width: 90%;
        min-height: 300px;
        margin: auto auto;
        text-align: center;
    }

    .e4h-multipleresults {
        display: flex;
        flex-direction: column;
        font-size: 85%;
    }
    .e4h-multipleresults img {
        max-width: 30%;
    }
    .e4h-subresult {
        margin-bottom: 20px;
    }
    .e4h-result {
        padding-top: 40px;
    }
    .e4h-result-description {
        font-size: 0.8em;
        font-weight: 400;
    }

    .e4h-result-row {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }

    .progressContainer {
        position: fixed;
        top: 20px;
        left: 0px;
        width: 100vw;
        text-align: center;
    }

    .progressContainer progress {
        width: 50%;
    }

    @media screen and (min-width: 1025px) {
        .e4h-quiz-container {
            width: 800px;
        }
        .e4hquizmultiplecontainer {
            width: 1000px;
        }
        .e4h-result {
            padding-top: 0px;
        }
        .e4h-result-row {
            flex-direction: row;
        }
        .e4h-multipleresults {
            flex-direction: row;
            font-size: 100%;
        }
        .e4h-multipleresults img {
            max-width: 100%;
        }
        .e4h-subresult {
            width: 50%;
        }
        .e4h-quiz-close {
            top: 20px;
            right: 80px;
        }
        .progressContainer {
            top: 20px;
            width: 100vw;
        }
        .progressContainer progress {
            width: 500px;
        }
    }

    .e4h-header {
        font-size: 1.5em;
        font-weight: 700;
        line-height: 1.2;
        color: #4dbcc6;
    }

    .e4h-large {
        font-size: 1.2em;
        line-height: 1.2;
        font-weight: 700;
    }

    .e4h-question {
        font-size: 1.2em;
        line-height: 1.2;
        font-weight: 700;
    }

    .e4h-answers {
        margin-top: 50px;
    }

    .e4h-answers-multiplechoice {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: stretch;
        align-content: stretch;
    }

    .e4h-answer-item {
        width: 100%;
        height: 50px;
        margin-bottom: 20px;
        display: block;
        border: 1px solid #4dbcc6;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .e4h-answer-item:not(.nohover):hover {
        background-color: white;
        border: 3px solid #4dbcc6;
    }

    .e4h-answer-item input[type=text] {
        margin-bottom: 0;
        border: none;
        border-bottom: 1px solid #4dbcc6;
        outline: none;
        background-color: transparent;
        text-align: center;
        box-shadow: none;
        width: 75px;
    }

    .backbutton {
        background-color: lightgray;
    }

    progress[value] {
        /* Reset the default appearance */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    progress[value]::-webkit-progress-bar {
        background-color: lightgray;
        border-radius: 5px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
    }
    progress[value]::-webkit-progress-value {
        background-image:
                -webkit-linear-gradient(top,
                rgba(255, 255, 255, .1),
                rgba(0, 0, 0, .1)),
                -webkit-linear-gradient(left, #95cace, #4dbcc6);
        border-radius: 5px;
        background-size: 35px 20px, 100% 100%, 100% 100%;
    }
    progress[value]::-moz-progress-bar {
        background-image:
                -moz-linear-gradient(
                        top,
                        rgba(255, 255, 255, 0.1),
                        rgba(0, 0, 0, 0.1)
                ),
                -moz-linear-gradient(
                        left,
                        #95cace,
                        #4dbcc6
                );

        border-radius: 5px;
        background-size: 35px 20px, 100% 100%, 100% 100%;
    }
</style>
